

































import { Vue, Component, Prop } from 'vue-property-decorator';
import ExtraKeyboardKey from './ExtraKeyboardKey.vue';
import messageBus from '../../utils/MessageBus';

interface ExtraKeyboardEventTarget {
  id: string;
  __vue__: { keyLabel: string };
}

type ExtraKeyboardEvent = { target: ExtraKeyboardEventTarget };

// noinspection JSUnusedGlobalSymbols
@Component({
  components: {
    ExtraKeyboardKey,
  },
})
export default class ExtraKeyboard extends Vue {
  shifted: boolean = false;
  disabled: boolean = false;

  @Prop() id!: string;

  // handle special keys
  keyInput(event: ExtraKeyboardEvent) {
    const { target }: ExtraKeyboardEvent = event;
    if (!target) {
      return;
    }

    // noinspection TypeScriptUnresolvedVariable
    const which: string = target.id;
    if (which === 'shift') {
      this.shifted = !this.shifted;
      return;
    }

    // determine character that corresponds to the key pressed and send event
    // eslint-disable-next-line no-underscore-dangle
    const myValue: string = target.__vue__.keyLabel;
    messageBus.$emit('extraKeyInput', myValue);
  }

  onEnableInput(isEnabled: boolean) {
    this.disabled = !isEnabled;
  }

  // noinspection JSUnusedGlobalSymbols
  mounted() {
    // handler to enable/disable input
    messageBus.$on('enableInput', this.onEnableInput);
  }

  // noinspection JSMethodCanBeStatic
  beforeDestroy(): void { // eslint-disable-line class-methods-use-this
    messageBus.$off('enableInput', this.onEnableInput);
  }
}
